export default "__VITE_ASSET__7EvC6gge__$_?component__"